<template>
  <div
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    :title="tooltip"
  >
    <span
      v-if="pill"
      :class="`badge badge-pill bg-gradient-${variant}`"
    >
      <i
        v-if="icon"
        class="me-1"
        :class="icon"
      />
      {{ text }}
    </span>
    <span
      v-else
      :class="`badge badge-${variant}`"
    >
      <i
        v-if="icon"
        class="me-1"
        :class="icon"
      />
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: "LevBadge",
  props: {
    text: {
      type: String,
      default: "Badge",
    },
    variant: {
      type: String,
      default: "primary",
    },
    pill: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    }
  }
}
</script>
